"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var watch_1 = require("../watch");
var proxy_1 = require("../proxy");
var iframe_1 = require("./iframe");
var storage_1 = require("./storage");
var instance = false;
function replayServerSideLogs(receivedBuffer) {
    if (!instance) {
        return;
    }
    receivedBuffer.forEach(function (item) {
        var callable = console[item.method];
        callable.apply(void 0, ['[SSR]'].concat(item.params));
    });
}
function createInstance() {
    var watcher = new watch_1.ChannelWatch(storage_1.BrowserStorage);
    var watch = watcher.watch, unwatch = watcher.unwatch, watching = watcher.watching;
    var proxy = new proxy_1.Proxy(console, watching);
    var error = proxy.error, warn = proxy.warn, info = proxy.info, log = proxy.log, trace = proxy.trace, createLogger = proxy.createLogger, list = proxy.list, alert = proxy.alert;
    var selfLogger = proxy.createLogger('ddt');
    iframe_1.initIframeSync(selfLogger, watcher);
    return {
        watch: watch,
        unwatch: unwatch,
        watching: watching,
        error: error,
        warn: warn,
        info: info,
        log: log,
        trace: trace,
        createLogger: createLogger,
        list: list,
        replayServerSideLogs: replayServerSideLogs,
        alert: alert,
    };
}
function getClientInstance() {
    if (!instance) {
        instance = createInstance();
        window.ddt = instance;
    }
    return instance;
}
exports.getClientInstance = getClientInstance;
//# sourceMappingURL=index.js.map